module.exports = __webpack_public_path__ + "static/media/famosaWhite@3x.44168c9f.png";